var map = {
	"./advance-local.scss": 7882,
	"./advance-local/_colours.scss": 9185,
	"./advance-local/_constants.scss": 6463,
	"./advance-local/_fonts.scss": 2907,
	"./ball-is-life.scss": 9992,
	"./ball-is-life/_colours.scss": 3686,
	"./ball-is-life/_constants.scss": 834,
	"./ball-is-life/_fonts.scss": 1890,
	"./basketball-forever.scss": 552,
	"./basketball-forever/_colours.scss": 4492,
	"./basketball-forever/_constants.scss": 838,
	"./basketball-forever/_fonts.scss": 2551,
	"./beasley.scss": 4810,
	"./beasley/_colours.scss": 3139,
	"./beasley/_constants.scss": 7641,
	"./beasley/_fonts.scss": 3678,
	"./dimers.scss": 9039,
	"./dimers/_colours.scss": 4226,
	"./dimers/_constants.scss": 3322,
	"./dimers/_fonts.scss": 2922,
	"./dimers2.scss": 4744,
	"./dimers2/_colours.scss": 394,
	"./dimers2/_constants.scss": 3392,
	"./dimers2/_fonts.scss": 3875,
	"./footyology.scss": 773,
	"./footyology/_colours.scss": 5740,
	"./footyology/_constants.scss": 4280,
	"./footyology/_fonts.scss": 4250,
	"./generic-test.scss": 627,
	"./generic-test/_colours.scss": 5279,
	"./generic-test/_constants.scss": 1347,
	"./generic-test/_fonts.scss": 6083,
	"./onetwenty.scss": 6682,
	"./onetwenty/_colours.scss": 865,
	"./onetwenty/_constants.scss": 2681,
	"./onetwenty/_fonts.scss": 979,
	"./pickswise.scss": 3129,
	"./pickswise/_colours.scss": 3608,
	"./pickswise/_constants.scss": 5847,
	"./pickswise/_fonts.scss": 6609,
	"./stats-insider.scss": 9536,
	"./stats-insider/_colours.scss": 1182,
	"./stats-insider/_constants.scss": 2503,
	"./stats-insider/_fonts.scss": 6982,
	"./wwos.scss": 7442,
	"./wwos/_colours.scss": 4408,
	"./wwos/_constants.scss": 7327,
	"./wwos/_fonts.scss": 8750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6638;